(function () {
  function initMatsuriFaq(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('.matsuri-faq__button');

    buttons.forEach(function (button) {
      if (button.dataset.matsuriBound === 'true') return;
      button.dataset.matsuriBound = 'true';

      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var expanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.hidden = expanded;
        }
      });
    });
  }

  function initVideoPosters(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-matsuri-video-empty]').forEach(function (button) {
      if (button.dataset.matsuriBound === 'true') return;
      button.dataset.matsuriBound = 'true';

      button.addEventListener('click', function () {
        button.classList.add('matsuri-video__poster--clicked');
      });
    });
  }

  /* Reveal the sticky mobile buy bar only after the visitor scrolls past the hero */
  function initStickyBar() {
    var bar = document.querySelector('.matsuri-stickybar');
    if (!bar || bar.dataset.matsuriBound === 'true') return;
    bar.dataset.matsuriBound = 'true';
    bar.style.transform = 'translateY(120%)';
    bar.style.transition = 'transform .25s ease';

    function onScroll() {
      var show = window.scrollY > 620;
      bar.style.transform = show ? 'translateY(0)' : 'translateY(120%)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init(root) {
    initMatsuriFaq(root);
    initVideoPosters(root);
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
